<header class="pc-header coded-header">
	<app-nav-logo [navCollapsed]="navCollapsed" (NavCollapse)="navCollapse()" />
	<div class="header-wrapper">
		<app-nav-left (NavCollapsedMob)="navCollapseMob()" />
		<app-nav-right />
	</div>
</header>
